import React from 'react';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';

interface StickerPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectSticker: (stickerId: string) => void;
}

const STICKERS = [
  '😀', '😃', '😄', '😁', '😆', '😅',
  '🤣', '😂', '🙂', '🙃', '😉', '😊',
  '😇', '🥰', '😍', '🤩', '😘', '😗',
  '😚', '😙', '🥲', '😋', '😛', '😜',
  '🤪', '😌', '😔', '😑', '😐', '😶',
  '🤐', '🤨', '🤔', '🤫', '🤥', '😲',
  '☹️', '🙁', '😮', '😯', '😲', '😳',
  '😦', '😧', '😨', '😰', '😥',
];

const StickerPicker: React.FC<StickerPickerProps> = ({
  isOpen,
  onClose,
  onSelectSticker,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalDialog sx={{ maxWidth: 400, width: '100%' }} aria-labelledby="sticker-title">
        <ModalClose />
        <Typography id="sticker-title" level="title-lg">
          Seleccionar sticker
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: 0.5,
          }}
        >
          {STICKERS.map((sticker, index) => (
            <IconButton
              key={index}
              variant="plain"
              sx={{ fontSize: '2rem' }}
              onClick={() => {
                onSelectSticker(sticker);
                onClose();
              }}
            >
              {sticker}
            </IconButton>
          ))}
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default StickerPicker;
